import { IAPIRoutes } from "../../../../config";

/**
 * Product Utilization repository.
 *
 * Auth headers are injected automatically by `apiProvider.getDefaultHeaders()`
 * for `/patient-centric-app-v2/...` routes — we deliberately do NOT pass an
 * `Authorization` header here (see cip-rules.mdc).
 */
export const ProductUtilizationRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}): IProductUtilizationRepository => {
  const { GET, POST } = APIProvider;

  const getNeoConversations: IProductUtilizationRepository["getNeoConversations"] =
    (payload) =>
      GET(APIRoutes.apiProductUtilizationNeoConversations, {
        start: payload.start,
        end: payload.end,
        exclude_internal: payload.exclude_internal,
        ignore_empty: payload.ignore_empty,
        // No default limit — omitting it makes the backend return EVERY
        // matching conversation (this is a BI surface; never truncated).
        ...(payload.limit != null ? { limit: payload.limit } : {}),
        offset: payload.offset ?? 0,
      });

  const getNeoConversation: IProductUtilizationRepository["getNeoConversation"] =
    (payload) =>
      GET(
        APIRoutes.apiProductUtilizationNeoConversation.replace(
          "{conversation_id}",
          String(payload.conversation_id)
        )
      );

  const filterNeoConversations: IProductUtilizationRepository["filterNeoConversations"] =
    (payload) =>
      POST(APIRoutes.apiProductUtilizationNeoConversationsFilter, {
        question: payload.question,
        conversation_ids: payload.conversation_ids,
      });

  return {
    getNeoConversations,
    getNeoConversation,
    filterNeoConversations,
  };
};
